// Temporary maintenance: set to false to restore the card issuance amount step.
export const CARD_ISSUANCE_MAINTENANCE = false;
